import dayjs from "dayjs";

export const LOGIN_URL = window.LOGIN_URL;
export const BRAND_PHONE_NUMBER = "0818 22 22 22";
export const BRAND_HOME_PAGE = "https://www.anpostinsurance.ie/";
export const payingGuestsOptions = [
    {
        name: "0",
        value: 0
    },
    {
        name: "1",
        value: 1
    },
    {
        name: "2",
        value: 2
    },
    {
        name: "3",
        value: 3
    },
    {
        name: "4",
        value: 4
    },
    {
        name: "5",
        value: 5
    },
    {
        name: "6",
        value: 6
    },
    {
        name: "7+",
        value: 7
    }
];

export const roomOptions = [
    {
        name: "1",
        value: 1
    },
    {
        name: "2",
        value: 2
    },
    {
        name: "3",
        value: 3
    },
    {
        name: "4",
        value: 4
    },
    {
        name: "5",
        value: 5
    },
    {
        name: "6",
        value: 6
    },
    {
        name: "7+",
        value: 7
    }
];

export const claimFreeYearOptions = [
    {
        name: "1",
        value: 1
    },
    {
        name: "2",
        value: 2
    },
    {
        name: "3",
        value: 3
    },
    {
        name: "4",
        value: 4
    },
    {
        name: "5",
        value: 5
    },
    {
        name: "6",
        value: 6
    },
    {
        name: "7",
        value: 7
    },
    {
        name: "8",
        value: 8
    },
    {
        name: "9+",
        value: 9
    }
];

export const ncdOptions = [
    {
        name: "0",
        value: 0
    },
    {
        name: "1",
        value: 1
    },
    {
        name: "2",
        value: 2
    },
    {
        name: "3",
        value: 3
    },
    {
        name: "4",
        value: 4
    },
    {
        name: "5+",
        value: 5
    }
];

export const voluntaryExcessOptions = [
    {
        name: "€0",
        value: 0
    },
    {
        name: "€100",
        value: 100
    },
    {
        name: "€150",
        value: 150
    },
    {
        name: "€200",
        value: 200
    },
    {
        name: "€250",
        value: 250
    },
    {
        name: "€300",
        value: 300
    },
    {
        name: "€350",
        value: 350
    },
    {
        name: "€400",
        value: 400
    },
    {
        name: "€450",
        value: 450
    },
    {
        name: "€500",
        value: 500
    },
    {
        name: "€550",
        value: 550
    },
    {
        name: "€600",
        value: 600
    },
    {
        name: "€650",
        value: 650
    },
    {
        name: "€700",
        value: 700
    },
    {
        name: "€750",
        value: 750
    },
    {
        name: "€800",
        value: 800
    },
    {
        name: "€850",
        value: 850
    },
    {
        name: "€900",
        value: 900
    },
    {
        name: "€950",
        value: 950
    },
    {
        name: "€1000",
        value: 1000
    },
    {
        name: "€1050",
        value: 1050
    },
    {
        name: "€1100",
        value: 1100
    },
    {
        name: "€1150",
        value: 1150
    },
    {
        name: "€1200",
        value: 1200
    },
    {
        name: "€2000",
        value: 2000
    },
    {
        name: "€5000",
        value: 5000
    }
];

export const euroIcon = (position: string = "left") => {
    return {
        name: "euro",
        position
    };
};

export enum DriverType {
    PROPOSER = "proposer",
    ADDITIONAL_DRIVER = "additional_driver"
}

export const buildingIcons = [
    {
        name: "DetachedHouse",
        value: "detachedYellow"
    },
    {
        name: "SemiDetachedHouse",
        value: "semiDetachedYellow"
    },
    {
        name: "Bungalow",
        value: "bungalowYellow"
    },
    {
        name: "TerracedHouse",
        value: "terraceYellow"
    },
    {
        name: "PurposeBuiltApartment",
        value: "apartmentYellow"
    },
    {
        name: "Flat",
        value: "flatYellow"
    },
    {
        name: "Maisonette",
        value: "maisonetteYellow"
    },
    {
        name: "CountryMansion",
        value: "mansionYellow"
    },
    {
        name: "FarmHouse",
        value: "farmYellow"
    },
    {
        name: "Default",
        value: "defaultHouseYellow"
    }
];

export const alarmOptions = [
    {
        name: "Yes, monitored 24hrs a day",
        value: "NSAIApprovedInstallerAlarmStandardToCentralStation"
    },
    {
        name: "Yes, not monitored",
        value: "NSAIApprovedInstallerAlarmStandard"
    },
    {
        name: "No",
        value: "None"
    }
];

export const unspecifiedItemsCoverOptions = [
    {
        name: "No",
        value: 0
    },
    {
        name: "€2,500",
        value: 2500
    },
    {
        name: "€5,000",
        value: 5000
    },
    {
        name: "€7,500",
        value: 7500
    },
    {
        name: "€15,000",
        value: 15000
    }
];

export const YEARS_RANGE = 125;
export const MAX_YEAR = dayjs().year();
export const MIN_YEAR = MAX_YEAR - YEARS_RANGE;

export const INSURER_NAMES = {
    Allianz: "Allianz",
    Aviva: "Aviva"
};

export enum DirectDebitStep {
    ACCOUNT_DETAILS = 0,
    BANK_DETAILS = 1,
    TERMS_AND_CONDITIONS = 2,
    DEPOSIT = 3
}

export enum SpecifiedItemType {
    PedalCycle = "PedalCycle"
}

export enum EndorsementCode {
    AlarmInstallation = "E02",
    EscapeOfWater = "E35",
    FloodExclusion = "F01",
    RestrictionExclusionOfCover = "E13",
    Subsidence = "E45",
    NoClaimsDiscount = "E46",
    LocksOnDoorsWindows = "E01"
}